"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90476],{

/***/ 112288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Flex; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, (props) => `
  display: flex;
  ${props.justifyContent ? `justify-content: ${props.justifyContent};` : ""}
  ${props.alignItems ? `align-items: ${props.alignItems};` : ""}
  ${props.flexDirection ? `flex-direction: ${props.flexDirection};` : ""}
`);
const Flex = (_a) => {
  var _b = _a, {
    children,
    onClick
  } = _b, props = __objRest(_b, [
    "children",
    "onClick"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    onClick: () => {
      if (onClick)
        onClick();
    }
  }, props), children);
};




/***/ }),

/***/ 76610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ NotFound; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(179185);
/* harmony import */ var _Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(112288);
/* harmony import */ var _Text_Text_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(327513);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const NotFound = (_a) => {
  var _b = _a, {
    text
  } = _b, props = __objRest(_b, [
    "text"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k, __spreadProps(__spreadValues({}, props), {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w, {
    height: 128,
    width: 128,
    src: "https://lh3.googleusercontent.com/XgEwa2HvKXekl8B_ZtYa45fM17dXbHLeQpUS9DP9wLzVNuVry88JZt00ZcVTGdIXG9c-2EpW1OYG1FOTgA"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Text_Text_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
    textAlign: "center",
    fontSize: 14,
    color: "#848788",
    marginTop: "24px"
  }, text || (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Kh\xF4ng t\xECm th\u1EA5y s\u1EA3n ph\u1EA9m n\xE0o")));
};




/***/ }),

/***/ 862010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AK": function() { return /* binding */ getComboName; },
/* harmony export */   "B1": function() { return /* binding */ getComboImageUrl; },
/* harmony export */   "IH": function() { return /* binding */ getAppliedPromotionsByCartPromotionGroupList; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "cC": function() { return /* binding */ formatPriceFull; },
/* harmony export */   "hJ": function() { return /* binding */ getDateStringWithFormat; },
/* harmony export */   "m8": function() { return /* binding */ getPromotionStatus; },
/* harmony export */   "rb": function() { return /* binding */ PromoItemType; }
/* harmony export */ });
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891004);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(883667);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(540415);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(473776);





const CURRENCY_CONFIG = {
  VND: {
    locale: "vi-VN",
    currency: "VND"
  },
  GHS: {
    locale: "en-GH",
    currency: "GHS"
  }
};
const formatPrice = (price, numberDisplayFormat) => {
  let formattedPrice = price;
  if (price) {
    formattedPrice = price.toLocaleString("vi-VN");
    if (numberDisplayFormat) {
      const [int, dec = ""] = formattedPrice.split(",");
      const formattedInt = int.replaceAll(".", numberDisplayFormat.thousandSeparator);
      formattedPrice = dec ? `${formattedInt}${numberDisplayFormat.decimalSeparator}${dec}` : formattedInt;
    }
  }
  return formattedPrice;
};
const formatPriceFull = (price, numberDisplayFormat, currency = "VND") => {
  var _a, _b, _c;
  if (price === null || price === void 0 || price === "")
    return price;
  const value = typeof price === "string" ? Number(price) : price;
  const { locale, currency: currencyCode } = CURRENCY_CONFIG[currency];
  const parts = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: 0
  }).formatToParts(value);
  const integer = parts.filter((p) => p.type === "integer" || p.type === "group").map((p) => p.value).join("").replace(/\D/g, "");
  const fraction = (_a = parts.find((p) => p.type === "fraction")) == null ? void 0 : _a.value;
  let formattedPrice = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  if (fraction) {
    formattedPrice += `,${fraction}`;
  }
  const currencySymbol = (_c = (_b = parts.find((p) => p.type === "currency")) == null ? void 0 : _b.value) != null ? _c : "";
  formattedPrice = `${formattedPrice}${currencySymbol}`;
  if (numberDisplayFormat) {
    const [int, dec = ""] = formattedPrice.split(",");
    const formattedInt = int.replaceAll(".", numberDisplayFormat.thousandSeparator);
    formattedPrice = dec ? `${formattedInt}${numberDisplayFormat.decimalSeparator}${dec}` : formattedInt;
  }
  return formattedPrice;
};
const sortItems = (childItems) => {
  return childItems.sort((left, right) => left.displayPriority > right.displayPriority ? 1 : -1);
};
const getComboName = (childItems) => {
  if (childItems.length === 0)
    return "";
  const primary = sortItems(childItems)[0];
  const comboLength = childItems.length;
  return comboLength === 1 ? primary.name : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("{{PrimaryName}} v\xE0 {{var0}} s\u1EA3n ph\u1EA9m kh\xE1c", {
    PrimaryName: primary.name,
    var0: comboLength - 1
  });
};
const getComboImageUrl = (childItems) => {
  if (childItems.length === 0)
    return [];
  return sortItems(childItems).map((item) => {
    var _a, _b;
    return item.imageUrl || ((_b = (_a = item.product) == null ? void 0 : _a.productInfo) == null ? void 0 : _b.imageUrl);
  });
};
const getDateStringWithFormat = (dateString, format = "HH:mm dd/MM/yyyy") => {
  try {
    return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Date(dateString), format);
  } catch (e) {
    return "";
  }
};
var PromoItemType = /* @__PURE__ */ ((PromoItemType2) => {
  PromoItemType2["GIFT"] = "gift";
  PromoItemType2["DISCOUNT"] = "discount";
  PromoItemType2["VOUCHER"] = "voucher";
  return PromoItemType2;
})(PromoItemType || {});
const getAppliedPromotionsByCartPromotionGroupList = (cartPromotionGroupList) => {
  const gifts = [];
  cartPromotionGroupList.forEach((blockPromotion) => {
    blockPromotion.promotions.forEach((promotion) => {
      if (promotion.cartPromotionId !== null) {
        gifts.push({
          imageUrl: promotion.imageUrl,
          name: promotion.title
        });
      }
    });
  });
  return gifts;
};
const getPromotionStatus = (cartPromotionId, isSelectable, groupType) => {
  if (groupType) {
    if (groupType === _teko_cart_v2__WEBPACK_IMPORTED_MODULE_2__/* .PromotionGroupType.GROUP_TYPE_DEFAULT */ .VM.GROUP_TYPE_DEFAULT) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.FIXED */ .d.FIXED;
    } else {
      if (!isSelectable) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.DISABLED */ .d.DISABLED;
      } else if (cartPromotionId === null) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.UNSELECTED */ .d.UNSELECTED;
      } else if (cartPromotionId !== null) {
        return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.SELECTED */ .d.SELECTED;
      }
    }
  } else {
    if (cartPromotionId === null && isSelectable) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.UNSELECTED */ .d.UNSELECTED;
    } else if (cartPromotionId === null && !isSelectable) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.DISABLED */ .d.DISABLED;
    } else if (cartPromotionId !== null && isSelectable) {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.SELECTED */ .d.SELECTED;
    } else {
      return _types_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PromotionStatus.FIXED */ .d.FIXED;
    }
  }
};




/***/ }),

/***/ 540415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/lang/vi.es.js
var viLang = {
	
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/lang/en.es.js
var enLang = {
	"Được phép nâng giá bán tối đa": "Max raised price allowed",
	"Giá muốn bán không được vượt quá {{var0}}": "Selling price cannot exceed {{var0}}",
	"Giá muốn bán không được nhỏ hơn giá sản phẩm": "Selling price cannot be less than supplier price",
	"Giá sản phẩm": "Supplier price",
	"Giá muốn bán": "Selling price",
	"Nhập số tiền": "Input amount",
	"Số tiền chênh:": "Gap amount:",
	"Sửa giá": "Edit price",
	"Dùng sau": "Use later",
	"Áp dụng": "Apply",
	"Bỏ chọn": "Unselect",
	"Tặng 1 Ba lô Acer": "Receive 1 Acer backpack",
	"Bạn chỉ có thể mua tối đa {{maximumValue}} sản phẩm": "You can only purchase max {{maximumValue}} products",
	"Chú ý": "Note",
	"Bạn muốn xoá sản phẩm này ra khỏi giỏ hàng?": "Are your sure to delete product from Cart?",
	"Đồng ý": "Agree",
	"Hủy bỏ": "Cancel",
	"Xóa": "Delete",
	"x{{ProductVoucherQuantity}} Voucher dùng cho đơn hàng sau": "x{{ProductVoucherQuantity}} Voucher used for next order",
	"Không bán chịu": "Not selling on credit",
	"{{PrimaryName}} và {{var0}} sản phẩm khác": "{{PrimaryName}} and {{var0}} other products",
	"Chỉ áp dụng trên một số sản phẩm": "Applicable for some specific products only",
	"Giảm": "Discount",
	"tối đa {{maxAmount}}": "max {{maxAmount}}",
	"Dành": "Applicable",
	"cho đơn hàng từ {{min}} đến {{max}}": "for the order from {{min}} to {{max}}",
	"cho đơn hàng tối thiểu {{min}}": "for the order from {{min}}",
	"cho đơn hàng dưới {{max}}": "for the order under {{max}}",
	"cho tất cả các đơn hàng": "for all orders",
	"Giảm {{percent}}% tối đa {{maxAmount}}": "{{percent}}% off up to {{maxAmount}}",
	"{{quantity}}x {{name}} Mã giảm giá cho đơn hàng sau": "{{quantity}}x {{name}} Discount code for next order",
	"Thành tiền": "Total",
	"Đơn giá": "Unit price",
	"Số lượng": "Quantity",
	"Khuyến mại hot": "Promotions hot",
	"HSD:": "Expiry date:",
	"Chương trình khuyến mại": "Promotions",
	"Sản phẩm ưu đãi": "Promotional products",
	"Tìm kiếm chương trình khuyến mại": "Search promotions",
	"Xem thêm": "Show more",
	"Rút gọn": "Collapse",
	"Tìm kiếm sản phẩm khuyến mại": "Search promotional products",
	"Không tìm thấy chương trình nào.": "No program found.",
	"Không tìm thấy sản phẩm nào.": "No product found.",
	"Lỗi": "Error"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-cart-virtual-6a37caca01/1/packages/ui-cart/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "ui-cart";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), {
    ns: NAMESPACE,
    interpolation: { escapeValue: false }
  }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 473776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PromotionStatus; }
/* harmony export */ });
var PromotionStatus = /* @__PURE__ */ ((PromotionStatus2) => {
  PromotionStatus2[PromotionStatus2["SELECTED"] = 0] = "SELECTED";
  PromotionStatus2[PromotionStatus2["UNSELECTED"] = 1] = "UNSELECTED";
  PromotionStatus2[PromotionStatus2["DISABLED"] = 2] = "DISABLED";
  PromotionStatus2[PromotionStatus2["FIXED"] = 3] = "FIXED";
  return PromotionStatus2;
})(PromotionStatus || {});




/***/ }),

/***/ 179185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; },
/* harmony export */   "x": function() { return /* binding */ WebpImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div((props) => ({
  maxWidth: "100%",
  position: "relative",
  overflow: "hidden",
  flex: "1 0 auto",
  display: "flex",
  cursor: props.onClick ? "pointer" : "unset",
  zIndex: 0,
  margin: "auto",
  borderRadius: props.borderRadius + "px",
  paddingBottom: props.height ? "" : `${100 / props.aspectRatio}%`,
  border: props.border ? "1px solid #e0e0e0" : "",
  height: props.height ? `${props.height}px !important` : "",
  width: props.width ? `${props.width}px` : "100%",
  backgroundImage: props.thumbnail ? `url("${props.thumbnail}")` : null,
  backgroundSize: props.thumbnail ? "cover" : null,
  contentVisibility: props.height && props.width ? "auto" : null
}));
const WebpImage = ({
  src,
  onClick,
  className,
  height,
  width,
  imageWidth,
  alt = "",
  decoding = "async",
  onLoad
}) => {
  const placeHolder = "data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
  let imageUrl = src ? src : placeHolder;
  let altImageUrl = null;
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    if (imageWidth || width) {
      imageUrl = `${imageUrl}=w${imageWidth || width}`;
    }
    const checkExt = /=[a-z0-9-]+$/;
    altImageUrl = imageUrl;
    imageUrl = `${imageUrl}${checkExt.test(imageUrl) ? "-rw" : "=rw"}`;
  }
  const imgError = (event) => {
    if (event.target.src !== placeHolder) {
      event.target.src = placeHolder;
    }
    return;
  };
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    width,
    height,
    onClick,
    className,
    alt,
    onError: imgError,
    src: imageUrl,
    loading: "lazy",
    decoding,
    onLoad
  });
  return altImageUrl ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: imageUrl,
    type: "image/webp"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    srcSet: altImageUrl,
    type: "image/png"
  }), imgEle) : imgEle;
};
const WrapperImage = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WebpImage)((props) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: ${props.contain ? "contain" : props.cover ? "cover" : ""};
  transition: transform 0.5s;
  &:hover {
    transform: ${props.hover === "zoom" ? "scale(1.05)" : ""};
  }
  `);
const LazyImage = ({
  src,
  onClick,
  className,
  contain = false,
  cover = false,
  aspectRatio = 1,
  height,
  width,
  alt = "",
  border = false,
  hover = "",
  borderRadius = 0,
  thumbnail,
  decoding = "async",
  imageWidth
}) => {
  const imgEle = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperImage, {
    hover,
    className: "lazyload",
    contain,
    imageWidth,
    cover,
    alt,
    "data-src": src,
    src,
    decoding
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height,
    width,
    border,
    aspectRatio,
    borderRadius,
    onClick,
    className,
    thumbnail
  }, imgEle);
};




/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(504133);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links , schemaPage  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const schemaPageJson = typeof schemaPage === "string" ? (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getJson */ .LK)(schemaPage) : schemaPage;
    const schemas = Array.isArray(schemaPageJson) ? schemaPageJson : schemaPageJson && [
        schemaPageJson
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            }),
            meta.fbDomainVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: meta.fbDomainVerificationContent
            }),
            !!(schemas === null || schemas === void 0 ? void 0 : schemas.length) && schemas.map((schema, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schema)
                    }
                }, index))
        ]
    });
};


/***/ }),

/***/ 809768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useNewsFeed; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _services_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(427342);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(106454);




const useNewsFeed = (param)=>{
    let { ssrNews , ssrTotalItems =0 , page =1 , feedId  } = param;
    const { 0: news , 1: setNews  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(ssrNews);
    const { 0: totalItems , 1: setTotalItems  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(ssrTotalItems);
    const [loading, setLoading] = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .useLoading */ .r$)("useNewsFeed");
    const { terminal  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setLoading(true);
        _services_search__WEBPACK_IMPORTED_MODULE_3__/* .searchService.getNewsFeed */ .u.getNewsFeed(terminal, feedId, page).then((param)=>{
            let { news: _news , totalItems: _total  } = param;
            setNews(_news);
            setTotalItems(_total);
        }).finally(()=>{
            setLoading(false);
        });
    }, [
        page
    ]);
    return {
        news,
        totalItems,
        loading
    };
};


/***/ }),

/***/ 331690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ NewsCard; }
/* harmony export */ });
/* unused harmony export stripNewsContent */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(179185);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(855271);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(479690);
/* harmony import */ var _teko_ui_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(862010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  line-height: 20px;\n  margin: 8px 0;\n  font-size: 1.25rem;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  color: #666;\n  font-size: 0.875rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 8px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0.5rem 1rem;\n  background-color: #ffffff;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






const NewsCard = (_param)=>{
    var { feed  } = _param, props = _objectWithoutProperties(_param, [
        "feed"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: {
            pathname: "/tin-tuc/[slug]",
            query: {
                slug: feed.urlKey
            }
        },
        as: "/tin-tuc/".concat((feed === null || feed === void 0 ? void 0 : feed.urlKey) || ""),
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FeedCard, _objectSpreadProps(_objectSpread({}, props), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .LazyImage */ .w, {
                    src: feed.imageUrl || "",
                    aspectRatio: 1.5,
                    cover: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FeedContent, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeedTitle, {
                            children: feed.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeedDate, {
                            children: feed.updateAt && (0,_teko_ui_cart__WEBPACK_IMPORTED_MODULE_5__/* .getDateStringWithFormat */ .hJ)(feed === null || feed === void 0 ? void 0 : feed.updateAt)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeedDescription, {
                            dangerouslySetInnerHTML: {
                                __html: stripNewsContent((feed === null || feed === void 0 ? void 0 : feed.content) || "")
                            }
                        })
                    ]
                })
            ]
        }))
    });
};
const FeedCard = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_2__.space, ()=>"\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgb(0 0 0 / 20%);\n  overflow: hidden;\n  cursor: pointer;\n  height: 100%;\n");
const FeedTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(_templateObject());
const FeedDate = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(_templateObject1());
const FeedDescription = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(_templateObject2());
const FeedContent = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(_templateObject3());
const stripNewsContent = (string)=>{
    return string.replace(/<\/?[^>]+>/gi, " ").replace(/<img[^>"']*((("[^"]*")|('[^']*'))[^"'>]*)*>/g, "").substring(0, 200);
};


/***/ })

}]);